import React from 'react';
import { FiCalendar, FiMoreHorizontal, FiPlus, FiStar } from 'react-icons/fi'
import { plans } from '../../../../dummy/plans';
export const DiesRegex = new RegExp(/\B#\w+/g);

const Calendar = () => {
    return (
      <React.Fragment>
          <div className="flex mx-2 justify-between mt-3 cursor-pointer">
                <h1 className="text-xl font-medium">Planned</h1>
                <div
                  className="bg-gray-200 dark:bg-gray-800 flex items-center justify-center rounded-md p-1 w-8 h-8"
                >
                  <FiMoreHorizontal
                    className="h-4 text-gray-500 dark:text-gray-500"
                  />
                </div>
              </div>

              {plans.map((plan,i)=>(
                 <React.Fragment key={`plan-${i}`} >

                 <div
                    className="bg-gray-200 flex w-max items-center justify-center rounded-md m-2 px-3 dark:bg-green-700/30 dark:text-green-100 bg-green-200/30 text-green-700"
                  >
                    {plan.group}
                  </div>
                  <ul>
                    {plan.list?.map((todo,key)=>(
                        <li
                        key={`list-${key}`}
                        className="group shadow-sm hover:bg-gray-100 dark:hover:bg-zinc-900 flex cursor-pointer bg-white dark:bg-zinc-800 mx-2 p-1 justify-between items-center rounded-md mb-3"
                        >
                         <label for="c1" className="flex w-full">
                        <div className="flex items-center mx-2">
                          <input
                            checked
                            id="c1"
                            type="checkbox"
                            value=""
                            className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                          />
                        </div>
                        <div>
                          <h3 className="">{todo.title?.trim().split('\n').map((item, key) => {
                            return item.split(' ').map((text,i)=>{

                              if(text?.match(DiesRegex))  return <span className="text-blue-500 cursor-pointer">{text}</span>
                              return `${text} `;

                          }) 
                          })
                           }</h3>
                          <div className="flex text-gray-400 items-center text-sm">
                            <div className="text-xs">{todo.category}</div>
                            <div className="flex text-xs items-center">
                              <FiCalendar className="h-3" /> {plan.group}
                            </div>
                          </div>
                        </div>
                      </label>
                     {todo.star  &&  <FiStar className="h-3" />  }
                      </li>
                    ))}
                  </ul>

 
                </React.Fragment>
              ))}

            
              <div
                className="flex items-center bg-green-200/50 text-green-700 dark:bg-green-800 dark:text-green-300 rounded-md p-3 m-3 cursor-pointer"
              >
                <FiPlus
                  className="h-5 stroke-green-700 dark:stroke-green-300"
                />
                Add a task due today
              </div>
      </React.Fragment>
    )
  }

export default Calendar;
